<template>
  <aside class="step_education">
    <a v-if="putContentInModal" @click="toggle" class="open_sidebar">
      <img v-if="hasImageSource" :src="toggleImage.src" :srcset="toggleImage.srcset" :alt="title" />
      <i>Read About {{ title }}</i>
    </a>
    <inline-modal container-class="step_education" :disable-portal="!putContentInModal" :requested="isEnabled || !putContentInModal" @modal-closed="close()">
      <h3 class="edu-title">{{ title }}</h3>
      <div class="edu-content" v-html="content"></div>
    </inline-modal>
  </aside>
</template>

<script>
import InlineModal from '../../InlineModal'

export default {
  components: {
    InlineModal
  },
  props: [
    'title',
    'content',
    'toggleImage'
  ],
  created() {
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
    this.$once('hook:destroyed', () => {
      window.removeEventListener('resize', this.handleResize)
    });
  },
  data() {
    return {
      enabled: false,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  methods: {
    close() {
      this.enabled = false;
    },
    toggle() {
      this.enabled = !this.enabled;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  computed: {
    putContentInModal() {
      return this.window.width < 992;
    },
    hasImageSource() {
      return this.toggleImage && 0 !== this.toggleImage.src.length;
    },
    isEnabled() {
      return this.enabled
    }
  },
}
</script>
